import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "bg-gray-100 p-4" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", { class: "text-2xl font-bold" }, "Dummy", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", null, " Lorem ipsum dolor sit amet, consectetur adipisicing elit. Ad, natus, officiis. Accusantium esse facilis laborum magni maiores neque omnis, quam. Corporis delectus enim ex harum illum ipsum necessitatibus quasi, ut. ", -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_4))
}